import { CalendarEntry } from './calendar-entry.js';
import { Service } from './serializable/service.js';

export abstract class OpenReservationBase extends CalendarEntry {
  abstract get serviceId(): string
  abstract get service(): Service
  abstract get clientOrderGroupId(): string
}
